import { useOutletContext, useNavigate, Link } from "react-router-dom";
import { Archive } from "lucide-react";
import KanbanBoard from "@/components/KanbanBoard";

export default function KanbanPage() {
  const ctx = useOutletContext();
  return (
    <div data-testid="kanban-page">
      <div className="mb-4 flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="text-xs font-bold uppercase tracking-widest text-slate-500">{ctx.project.workspace_name}</div>
          <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mt-2">Quadro Kanban</h1>
          <p className="text-slate-500 mt-1">Arraste os cartões entre colunas. A coluna define o status da tarefa.</p>
        </div>
        <Link to={`/projetos/${ctx.projectId}/arquivadas`} data-testid="kanban-archived-link" className="inline-flex items-center gap-2 h-9 px-3 rounded-lg border border-slate-200 text-sm text-slate-600 hover:bg-slate-50"><Archive className="w-4 h-4" /> Arquivadas</Link>
      </div>
      <KanbanBoard projectId={ctx.projectId} refreshKey={ctx.refreshKey} onOpenTask={ctx.openTask} onChanged={ctx.bump} />
    </div>
  );
}
